module.exports = __webpack_public_path__ + "static/img/featrue2.75dcb393.jpg";